import { render, staticRenderFns } from "./AdminJoin.vue?vue&type=template&id=fbdf4770"
import script from "./AdminJoin.vue?vue&type=script&lang=js"
export * from "./AdminJoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports